import React, { useState, useCallback, useEffect } from "react"
import { Container, Row, Card, CardHeader, CardBody } from "reactstrap"
import LightHeader from "components/Headers/LightHeader"
import api from "services/api"
import moment from "moment"

import PastDueTable from "components/Tables/admin/PastDueTable"
import CreatePastDueAppointment from "components/Modals/create/CreatePastDueAppointment"
import PastDueAppointmentTableHeader from "components/TableHeaders/admin/PastDueAppointmentTableHeader"
import ServiceDeskTableHeader from "components/TableHeaders/admin/ServiceDeskTableHeader"

export default function PastDueAppointment() {
  const [loading, setLoading] = useState(false)
  const [to, setTo] = useState(moment().endOf("month").format("YYYY-MM-DD"))
  const [from, setFrom] = useState(moment().startOf("month").format("YYYY-MM-DD"))
  const [data, setData] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [editData, setEditData] = useState(null)

  const fetchPastDue = useCallback(async () => {
    setLoading(true)
    try {
      const response = await api.post("pastDue/search", { 
        dateTo: to, 
        dateFrom: from 
      })

      const treatedData = response.data.map(item => ({
        ...item,
        customerName: item.customer?.shortName || "N/A",
        projectName: item.project?.name || "N/A",
      }))

      setData(treatedData)
    } catch (error) {
      console.error("Erro ao carregar lista", error)
    } finally {
      setLoading(false)
    }
  }, [from, to])

  useEffect(() => {
    fetchPastDue()
  }, [fetchPastDue])

  const handleOpenModal = () => {
    setEditData(null)
    setModalOpen(true)
  }

  const handleEdit = (item) => {
    setEditData(item)
    setModalOpen(true)
  }

  const handleDelete = async (id) => {
    if (window.confirm("Deseja realmente excluir este apontamento?")) {
      try {
        await api.delete(`pastDue/delete/${id}`)
        fetchPastDue()
      } catch (error) {
        alert("Erro ao excluir")
      }
    }
  }

  return (
    <>
      <LightHeader title="Apontamentos Horas Vencidas" parent="Cadastros" menuTitle="Vencidas" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <ServiceDeskTableHeader to={to} from={from} setTo={setTo} setFrom={setFrom} fetchContracts={fetchPastDue} />
                <div className="mt-3">
                  <PastDueAppointmentTableHeader openCreateAppointment={handleOpenModal} />
                </div>
              </CardHeader>
              <CardBody style={{ overflowX: "auto", padding: "0px", minHeight: "20vh" }}>
                <PastDueTable 
                  data={data} 
                  loading={loading} 
                  onEdit={handleEdit} 
                  onDelete={handleDelete} 
                />
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
      <CreatePastDueAppointment 
        isOpen={modalOpen} 
        editData={editData} 
        closeModal={() => setModalOpen(false)} 
        updateList={fetchPastDue} 
        showAlert={(msg) => alert(msg)} 
      />
    </>
  )
}